import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textTransform',
  standalone: true
})
export class TextTransformPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    return value?.trim()?.trim()?.split(' ')?.join('-')?.toLowerCase();
  }
}
